import { Button, GlobalStyles, Paper } from "@mui/material";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Footer } from "../../../components/Footer";
import { AppContext } from "../../../context";
import { Star } from "../../../images/star";

export const EwqPyamentPending = () => {
  const { logo, getLead, contact, finalSentence } = useContext<any>(AppContext);
  const [lead, setLead] = useState<any>();
  const params: any = useParams();
  useEffect(() => {
    console.log(finalSentence);
    getAndSetLead();
  }, []);
  const getAndSetLead = async () => {
    const res = await getLead(params.id);
    setLead(res);
    console.log(lead);
  };
  return (
    <>
      {lead && lead.urlBankSlip && (
        <Container component="main" maxWidth="md">
          <GlobalStyles
            styles={{
              body: {
                backgroundColor: `white`,
              },
            }}
          />
          <Paper
            variant="outlined"
            elevation={0}
            sx={{
              my: 3,
              // backgroundColor: `#dcdcdc`,
              display: "flex",
              flexDirection: "column",
              height: "90vh",
              justifyContent: "space-evenly",
              alignItems: "center",
            }}
          >
            <img
              src={logo}
              alt=""
              style={{ margin: "0 auto", width: "250px" }}
            />
            <Typography
              sx={{
                color: "primary.main",
                fontSize: "2.4rem",
                px: 1,
                fontWeight: "bold",
              }}
              align="center"
            >
              Boleto gerado com sucesso!
            </Typography>
            <Box sx={{ mx: "auto" }}>
              <Star />
            </Box>
            <Typography
              sx={{ color: "primary.main", fontSize: "1.5rem", px: 1 }}
              align="center"
            >
              Faça o download do seu boleto.
            </Typography>
            <Button
              sx={{ my: 2, width: 150 }}
              target="_blank"
              href={lead.urlBankSlip}
              variant="contained"
              color="primary"
              type="button"
            >
              Download
            </Button>
            {finalSentence ? (
              <Typography
                sx={{ color: "primary.main", fontSize: "1.3rem", px: 1 }}
                align="center"
              >
                {finalSentence} Em caso de dúvida entre em contato:{" "}
                {contact ? contact : "atendimento@briasaude.com"}
              </Typography>
            ) : (
              <Typography
                sx={{ color: "primary.main", fontSize: "1.5rem", px: 1 }}
                align="center"
              >
                Em até 48h seus benefícios serão ativados. Em caso de dúvida
                entre em contato:{" "}
                {contact ? contact : "atendimento@briasaude.com"}
              </Typography>
            )}
            <Box
              sx={{
                width: "100%",
                alignItems: "center",
              }}
            >
              <Footer />
            </Box>
          </Paper>
        </Container>
      )}
    </>
  );
};
